export default "__VITE_ASSET__lMUt$Wm9__"